// extracted by mini-css-extract-plugin
export default {"ordersPage":"H0Bm8Jkx","header":"qo8jrHpd","actions":"Za06a9Fe"};